import { createAction, props } from '@ngrx/store';
export const updateHasSupportedNetwork = createAction(
    '[Network] Update Supported Network',
    props<{ supportedNetwork: boolean }>(),
);
